<template>
  <div class="steps">
    <a-steps direction="vertical">
      <!-- <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="选择模型"
          />
        </template>
        <template slot="description">
          <a-select default-value="GPT4.0" style="width: 300px; margin: 8px;" size="large" v-model="model">
            <a-select-option value="GPT4.0">
              GPT-4.0
            </a-select-option>
          </a-select>
        </template>
      </a-step> -->
      <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="修改设定"
          />
        </template>
        <template slot="description">
          <p style="font-size:16px;color:#000000;">1、点击左侧对应窗口的设置按钮，可设置部分参数</p>
          <p style="font-size:16px;color:#000000;">2、具体设置请自行查看设置界面及里面的帮助信息</p>
        </template>
      </a-step>
      <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="注意事项"
          />
        </template>
        <template slot="description">
          <p style="font-size:16px;width:500px;text-align:justify;line-height:1.8;color:#000000;">1、4.0Turbo版本默认上下文数量为0，即AI没有记忆能力。该选项可在聊天窗口的设置中通过【上下文数量】参数进行修改，最大支持100000，但是增大上下文数量会增加费用消耗。</p>
          <p style="font-size:16px;color:#000000;">2、偶尔可能生成不正确、有害或有偏见的内容</p>
          <p style="font-size:16px;color:#000000;">3、对2023年后的世界和事件了解有限</p>
          <p style="font-size:16px;color:#000000;">4、不正当的请求可能会被拒绝</p>
          <p style="font-size:16px;color:#000000;">5、必须保持Hiplot正常登录状态方可使用</p>
        </template>
      </a-step>
      <a-step status="process">
        <template slot="title">
          <a-page-header
            style="padding: 0px 0px 10px 0px;"
            title="开始提问"
          />
        </template>
        <template slot="description">
          <div class="example" @click="exampleChat('我爸妈结婚为什么没有通知我？')">
            <a-row>
              <a-col :span="23">
                <p style="font-size:16px;color:#000000;">我爸妈结婚为什么没有通知我？</p>
              </a-col>
              <a-col :span="1">
                <a-icon style="font-size:16px;padding-top:3px;" type="right-circle" />
              </a-col>
            </a-row>
          </div>
          <div class="example" @click="exampleChat('用R语言写一份绘制热图的代码')">
            <a-row>
              <a-col :span="23">
                <p style="font-size:16px;color:#000000;">用R语言写一份绘制热图的代码</p>
              </a-col>
              <a-col :span="1">
                <a-icon style="font-size:16px;padding-top:3px;" type="right-circle" />
              </a-col>
            </a-row>
          </div>
          <div class="example" @click="exampleChat('树上9只鸟，猎人开枪打死一只，树上还剩几只鸟？')">
            <a-row>
              <a-col :span="23">
                <p style="font-size:16px;color:#000000;">树上9只鸟，猎人开枪打死一只，树上还剩几只鸟？</p>
              </a-col>
              <a-col :span="1">
                <a-icon style="font-size:16px;padding-top:3px;" type="right-circle" />
              </a-col>
            </a-row>
          </div>
          <div  style="height:60px;"></div>
        </template>
      </a-step>
    </a-steps>
  </div>
</template>

<script>
export default {
  name: 'ChatInit',
  props: {
    loading: Boolean
  },
  data() {
    return {
      model: 'GPT4.0'
    }
  },
  methods: {
    exampleChat(data) {
      if (!this.loading) {
        this.$emit('emitSubmit',data)
      }
    }
  }
}
</script>

<style scoped>

.steps {
  padding-top: 20px;
  padding-left: calc(100% / 2 - 300px);
}

.content {
  text-align: center;
  margin: 0 auto;
}

.example {
  height:50px;
  margin:10px 5px 10px 5px;
  border-radius: 6px;
  padding: 13px;
  cursor: pointer;
  background: rgb(230, 230, 240);
  width: 420px;
}

.example:hover {
  height:50px;
  margin:10px 5px 10px 5px;
  background: rgba(200, 200, 200, 0.2);
  border-radius: 6px;
  cursor: pointer;
  padding: 13px;
}

</style>
